import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'src/store';
import { TopCollectionsAdapter } from './top-collections.adapter';

export const topCollectionsSelect = (state: RootState) => state.features.collections.topCollections;

export const collectionSelectors = TopCollectionsAdapter.getSelectors();

export const selectTopCollectionsEntities = createSelector(
    topCollectionsSelect,
    (state) => collectionSelectors.selectAll(state)
);

export const selectTopCollectionsLoading = createSelector(topCollectionsSelect, (state) =>
    state.isLoading
);
